import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';
import { SimpleButton } from '@/src/ui';
import { apiRequest } from '@/src/services';

import type { StandardDTO } from '../models/standardsDTO';

interface DeleteStandardModalProps {
    open: boolean;
    standard: StandardDTO;
    onClose: () => void;
    onDeleted: () => void;
    setError: (msg: string) => void;
}

const DeleteStandardModal: React.FC<DeleteStandardModalProps> = ({
    open,
    standard,
    onClose,
    onDeleted,
    setError,
}) => {
    const [submitting, setSubmitting] = useState(false);

    const handleDelete = async () => {
        setError('');
        setSubmitting(true);
        try {
            await apiRequest('DELETE', `standards/${standard.id}`);
            onDeleted();
        } catch {
            setError('Failed to delete standard');
        }
        setSubmitting(false);
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', margin: 'auto', mt: 8, width: 400 }}>
                <h2>Delete Standard</h2>
                <p>Are you sure you want to delete this standard?</p>
                <p>
                    <strong>Name:</strong> {standard.name}
                </p>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                    <SimpleButton variant="outlined" onClick={onClose} disabled={submitting}>
                        Cancel
                    </SimpleButton>
                    <SimpleButton
                        variant="contained"
                        color="error"
                        onClick={handleDelete}
                        disabled={submitting}
                    >
                        Delete
                    </SimpleButton>
                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteStandardModal;
